import { DriverStep } from '../types/DriverStep'

export const planningTourSteps: DriverStep[] = [
  {
    element: '#tab-planning-nav',
    popover: {
      title: 'Planning',
      description: 'The Planning page allows you to manage your delivery operations before they begin. You can create scenarios to organize orders, handle incoming deliveries from the inbox, and optimize routes. Once you\'ve finalized your plan, you can publish the scenario to convert it into an operational runsheet.',
    },
  },
  {
    element: '#planning-tree-view',
    popover: {
      title: 'Planning Tree',
      description: 'This is where you manage your orders and scenarios.',
    },
  },
  {
    element: '#planning-order-tree',
    popover: {
      title: 'Planning Orders',
      description: 'All new orders arrive in the inbox and can be either a delivery, a pickup, or a combination of both (mixed order). To view the inbox orders, drag the inbox and drop it onto the planning workspace.',
    },
  },
  {
    element: '#planning-scenario-tree',
    popover: {
      title: 'Planning Scenario',
      description: 'A scenario contains a collection of orders and runs. It allows dispatchers to assign orders to runs and optimize delivery routes before the actual operation date. Scenarios enable users to create and evaluate different delivery arrangements to determine the most efficient solution.',
    },
  },
  {
    element: '#planning-widget-dock',
    popover: {
      title: 'Widget Toolbar',
      description: 'This is your widget toolbar. Each widget represents a tool, and you can drag a widget from here and drop it into the workspace to open a tool.',
    },
  },
  {
    element: '#planning-workspace',
    popover: {
      title: 'Planning Workspace',
      description: 'This is your main workspace. View your scenario & run operations by dragging inbox, scenarios, and runs from the planning tree and dropping them here. Use widgets from the toolbar to visualize and analyze your operations. The workspace supports drag-and-drop functionality for easy window management.',
      side: 'top',
      align: 'end',
    },
  },
  {
    popover: {
      title: 'All Set!',
      description: 'You\'re all set to start planning your routes. Add a few orders and create a scenario to get started.',
    },
  },
]
